import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function HowView() {
    return (
        <>
            <Typography variant="h1" color="primary" gutterBottom>
                Wat is OpenVerkiezingen?
            </Typography>
            <Typography variant="body1" component="p">
                OpenVerkiezingen is een hulpmiddel om de verkiezingsprogramma’s van politieke
                partijen makkelijker te begrijpen.
            </Typography>
            <Typography variant="body1" component="p">
                Je kunt een eigen stellingen bedenken, of kiezen uit voorbeeldstellingen. Daarna kun
                je de partijen kiezen waarvan je de standpunten wilt zien. OpenVerkiezingen zoekt
                dan in de verkiezingsprogramma’s naar teksten die bij jouw stelling passen. Ook
                krijg je een korte samenvatting.
            </Typography>
            <Typography variant="body1" component="p">
                Zo bepaal jij als gebruiker zelf welke onderwerpen belangrijk voor je zijn en waar
                je meer over wilt lezen.
            </Typography>
            <Typography variant="h1" color="primary" gutterBottom>
                Hoe werkt OpenVerkiezingen?
            </Typography>
            <Typography variant="h2" color="secondary" gutterBottom>
                Stap 1. Het omzetten van de verkiezingsprogramma&apos;s
            </Typography>
            <Typography variant="body1" component="p">
                Politieke partijen publiceren hun verkiezingsprogramma vaak als een PDF. Deze PDF
                bestanden hebben een eigen stijl en indeling. Om de verkiezingsprogramma’s met
                elkaar te kunnen vergelijken, worden alle programma’s omgezet naar één
                standaardvorm. Dat gebeurt als volgt: elk verkiezingsprogramma wordt opgeknipt in
                kleine stukken tekst, van één tussenkop tot de volgende tussenkop. Zo wordt elk
                verkiezingsprogramma een verzameling van korte teksten. Zie het beleid voor een
                uitgebreidere uitleg over de methode.
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    p: '25px',
                    pl: {
                        xs: '0px',
                        sm: '30px'
                    },
                    pr: {
                        xs: '0px',
                        sm: '30px'
                    }
                }}>
                <img
                    src="/contentImages/how_program_to_pieces.svg"
                    style={{ width: '100%' }}
                    alt="De verkiezingsprogramma's worden in stukken geknipt"
                />
            </Box>
            <Typography variant="h2" color="secondary" gutterBottom>
                Stap 2. Doorzoekbaar maken van de verkiezingsprogramma&apos;s
            </Typography>
            <Typography variant="body1" component="p">
                De volgende stap is het doorzoekbaar maken van alle losse tekstfragmenten. Zoeken op
                losse woorden is niet genoeg. Stel dat iemand zoekt op “Nederland moet investeren in
                AI”. Dan moet een tekst over “kunstmatige intelligentie” of “kansen van ChatGPT voor
                het MKB” ook gevonden worden. Daarom gebruiken we semantic search.
            </Typography>
            <Typography variant="body1" component="p">
                Je kunt semantic search zien als een soort kaart. Op die kaart liggen fragmenten met
                hetzelfde onderwerp dicht bij elkaar. Fragmenten met verschillende onderwerpen
                liggen juist ver uit elkaar. Voor deze techniek gebruikt OpenVerkiezingen de
                technologie van de Amsterdamse startup Weaviate.
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    p: '25px',
                    pl: {
                        xs: '0px',
                        sm: '30px'
                    },
                    pr: {
                        xs: '0px',
                        sm: '30px'
                    }
                }}>
                <img
                    src="/contentImages/how_pieces_to_vectors.svg"
                    style={{ width: '100%' }}
                    alt="De verkiezingsprogramma's worden omgezet naar een semantische kaart"
                />
            </Box>

            <Typography variant="h2" color="secondary" gutterBottom>
                Stap 3. Tekstfragmenten zoeken bij een stelling
            </Typography>
            <Typography variant="body1" component="p">
                Wanneer een gebruiker een stelling invoert, bijvoorbeeld “Nederland moet meer
                investeren in digitale technologie”, plaatst OpenVerkiezingen deze stelling op de
                kaart. Vervolgens zoeken we welke tekstfragmenten uit de gekozen
                verkiezingsprogramma’s dichtbij de stelling liggen. Bij deze stelling kunnen dat
                bijvoorbeeld tekstfragmenten over “digitale veiligheid en weerbaarheid” of
                “investeringen in AI”.
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    p: '25px',
                    pl: {
                        xs: '0px',
                        sm: '30px'
                    },
                    pr: {
                        xs: '0px',
                        sm: '30px'
                    }
                }}>
                <img
                    src="/contentImages/how_search.svg"
                    style={{ width: '100%' }}
                    alt="De verkiezingsprogramma's worden doorzocht"
                />
            </Box>

            <Typography variant="h2" color="secondary" gutterBottom>
                Stap 4. Resultaten op de stelling tonen
            </Typography>
            <Typography variant="body1" component="p">
                De gevonden tekstfragmenten laten we zien aan de gebruiker. Deze tekstfragmenten
                geven aan wat het standpunt van de partij is op de stelling. Daarnaast maakt
                OpenVerkiezingen een samenvatting van het standpunt van de partij, met behulp van
                een taalmodel dat vergelijkbaar is met ChatGPT. Het taalmodel bedenkt niet zelf het
                antwoord, maar geeft op basis van de gevonden tekstfragmenten een samenvatting. Zo
                verkleinen we de kans dat er onjuiste informatie wordt gegeven.
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    p: '25px',
                    pl: {
                        xs: '0px',
                        sm: '30px'
                    },
                    pr: {
                        xs: '0px',
                        sm: '30px'
                    }
                }}>
                <img
                    src="/contentImages/how_search_to_result.svg"
                    style={{ width: '100%' }}
                    alt="De verkiezingsprogramma's worden gepresenteerd aan de gebruiker"
                />
            </Box>
        </>
    );
}
